import { Injectable } from '@angular/core';

import { TILING_CANVAS_ROOT_PATH } from './tiling-canvas-paths';

@Injectable({
  providedIn: 'root',
})
export class LaunchTilingCanvasService {
  private _tilingCanvasWindow: Window | null = null;

  public openWindow(): void {
    if (!this._tilingCanvasWindow || this._tilingCanvasWindow.closed) {
      this._tilingCanvasWindow = window.open(
        TILING_CANVAS_ROOT_PATH,
        'ExternalTilingCanvasToolWindow',
        'popup',
      );
    }

    this._tilingCanvasWindow?.focus();
  }
}
